<ng-container *ngIf="loading">
  <mat-spinner color="primary" diameter="18"></mat-spinner>
</ng-container>
<ng-container *ngIf="!loading">
  <div>
    <mat-checkbox
      [(ngModel)]="withSticker"
      (ngModelChange)="withStickerChanged()"
      ><span class="strong">Ineens met sticker op bord</span>
      <span *ngIf="ipBoard.leftRightBoard" class="side-label">{{ label }}</span>
    </mat-checkbox>
  </div>

  <ng-container *ngIf="withSticker">
    <mat-card class="top-card mat-elevation-z0">
      <div class="association-picker">
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            [placeholder]="'Maak een keuze'"
            [(value)]="selectedOption"
            (selectionChange)="setOptionValue($event.value)"
          >
            <mat-option
              *ngFor="let option of associationOptions"
              [value]="option"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div
          *ngIf="selectedOption != null && selectedOption.value === null"
          class="other-value-input"
        >
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="{{ otherValuePlaceholder }}"
              [(ngModel)]="otherValue"
              (ngModelChange)="setOtherValue()"
            />
          </mat-form-field>
        </div>
      </div>
    </mat-card>
  </ng-container>
</ng-container>
